export enum ListInputIconTypes {
  camera = 'camera-icon'
}
